// import { useHealthblocksTranslations } from '@bothrs/translations'
import { useLocal, useProjectFallback } from '@healthblocks-io/core'

import { HealthblocksMemberProvider } from '../healthblocks-member-providers/HealthblocksMemberProvider'

import type { ReactElement, ReactNode } from 'react'

type Props = { children: ReactNode }

const HealthblocksAppProvider = ({ children }: Props) => {
  const fallback = useProjectFallback()
  const localState = useLocal()

  if (!localState || fallback) {
    return <>{children}</>
  }

  return <HealthblocksMemberProvider>{children as unknown as ReactElement}</HealthblocksMemberProvider>
}

export { HealthblocksAppProvider }
